import type { LanguageCode } from "config/languages";
import { getParentLanguage } from "utils/localeUtils";
import { LOGOTYPES } from "modules/common/consts";

export const getLocalizedLogotypes = (language: LanguageCode) =>
  LOGOTYPES[language] || LOGOTYPES[getParentLanguage(language)] || LOGOTYPES.en;
